<template>
  <transition name="modal">

<!-- New Modal -->
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-custom-class="" data-has-cancel-button="true" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; margin-top: -191px;">
        <div class="modal-close col-sm-12 text-right">
          <button class="modal-button" @click="closeModal()"><span class="icon-close"></span></button>
        </div>
        <header class="modal-header">
          <h2 class="modal-title ">Transactions</h2>
          <div v-if="showInformationMessage" class="panel-body account-notice">
            <div class="alert alert-info alert-dismissible mt-lg" role="alert">
              <p id="transaction-message">{{informationMessage}}</p>
            </div>
          </div>
          <h4 class="modal-subtitle">
            Note number: {{noteId}}
          </h4>
        </header>
        <div class="transaction-table-scroll-wrap">
          <div
            ref="tableScroll"
            class="table-responsive bottom-margin"
            @scroll="onTableScroll"
          >
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="text-center">Date</th>
                  <th class="text-right">Amount</th>
                  <th class="text-center">Transaction type</th>
                  <th class="text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(t, index) in transactions" :key="index">
                  <td class="text-center">{{formatDate(t.createdAt)}}</td>
                  <td class="text-right">{{formatAmount(t.amount)}}</td>
                  <td class="text-center">{{formatType(t.type, 'investor', t.fundingSourceId)}}</td>
                  <td class="text-center">
                    <span class="label label-danger" v-if="isFailTransaction(t)">Failed</span>
                    <span class="label label-danger" v-if="isCancelTransaction(t)">Cancelled</span>
                    <span class="label label-warning" v-if="isPurchaseFailedTransaction(t)">Pending</span>
                    <span class="label label-danger" v-if="isPurchaseFailedTransactionWithSelectedErrorsCode(t)">Failed</span>
                    <span class="label label-warning" v-if="t.status == 'PENDING'">{{formatStatus(t.status)}}</span>
                    <span class="label label-success" v-if="t.status == 'PROCESSED'">{{formatStatus(t.status)}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button
            v-show="showScrollRightHint"
            type="button"
            class="transaction-scroll-right-btn"
            aria-label="Scroll table all the way to the right"
            @click="scrollTableToEnd"
          >
            <em class="fa fa-chevron-right" aria-hidden="true"></em>
          </button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
  import {
    mapMutations,
    mapState,
  } from 'vuex';
  import {
    HIDE_TRANSACTION_MODAL,
  } from '@/store/mutation-types';

  import { formatDate, formatAmount, formatType, formatStatus, isFailTransaction,
    isCancelTransaction, isPurchaseFailedTransaction, isPurchaseFailedTransactionWithSelectedErrorsCode } from '@/util';

  const mix = {
    methods: {
      formatDate,
      formatAmount,
      formatType,
      formatStatus,
      isFailTransaction,
      isCancelTransaction,
      isPurchaseFailedTransaction,
      isPurchaseFailedTransactionWithSelectedErrorsCode,
    },
  };

  export default {
    name: 'transaction',
    data() {
      return {
        showScrollRightHint: false,
      };
    },
    props: {
      closeAction: {
        type: Function,
        required: false,
        default: () => {},
      },
      informationMessage: {
        type: String,
        required: false,
        default: '',
      },
    },
    mixins: [mix],
    watch: {
      transactions: {
        handler() {
          this.$nextTick(() => this.updateScrollRightHint());
        },
        deep: true,
      },
    },
    mounted() {
      this.$nextTick(() => this.initTableScrollHint());
    },
    beforeDestroy() {
      this.teardownTableScrollHint();
    },
    computed: {
      ...mapState('transactionModal', [
        'noteId',
        'transactions',
        'noteOpenedOn',
      ]),
      showInformationMessage() {
        return new Date(this.noteOpenedOn) < new Date(2013, 1, 1);
      },
    },
    methods: {
      ...mapMutations('transactionModal', {
        hideTransactionModal: HIDE_TRANSACTION_MODAL,
      }),
      closeModal() {
        this.hideTransactionModal();
        if (typeof this.closeAction === 'function') {
          this.closeAction();
        }
      },
      onTableScrollResize() {
        this.updateScrollRightHint();
      },
      onTableScroll() {
        this.updateScrollRightHint();
      },
      initTableScrollHint() {
        const el = this.$refs.tableScroll;
        if (!el) {
          return;
        }
        if (typeof window !== 'undefined' && window.ResizeObserver) {
          this.tableScrollResizeObserver = new window.ResizeObserver(() => {
            this.updateScrollRightHint();
          });
          this.tableScrollResizeObserver.observe(el);
        }
        window.addEventListener('resize', this.onTableScrollResize);
        this.updateScrollRightHint();
      },
      teardownTableScrollHint() {
        window.removeEventListener('resize', this.onTableScrollResize);
        if (this.tableScrollResizeObserver) {
          this.tableScrollResizeObserver.disconnect();
          this.tableScrollResizeObserver = null;
        }
      },
      updateScrollRightHint() {
        const el = this.$refs.tableScroll;
        if (!el) {
          this.showScrollRightHint = false;
          return;
        }
        const maxScroll = el.scrollWidth - el.clientWidth;
        const epsilon = 2;
        const hasOverflow = maxScroll > epsilon;
        const notAtEnd = el.scrollLeft < maxScroll - epsilon;
        this.showScrollRightHint = hasOverflow && notAtEnd;
      },
      scrollTableToEnd() {
        const el = this.$refs.tableScroll;
        if (!el) {
          return;
        }
        const maxLeft = el.scrollWidth - el.clientWidth;
        el.scrollTo({ left: maxLeft, behavior: 'smooth' });
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .modal-wrapper p {
    font-size: 16px;
    text-align: center;
  }
  .modal-header {
    padding: 2%;
  }
  .modal-subtitle {
    font-size: 16px;
    font-weight: normal;
  }

  .account-notice {
    padding: 0;
  }

  .mt-lg {
    margin-top: 0 !important;
  }

  #transaction-message {
    text-align: left;
    font-size: 14px;
  }

  .transaction-table-scroll-wrap {
    position: relative;
  }

  .transaction-scroll-right-btn {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
    color: #337ab7;
    cursor: pointer;
    font-size: 12px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .transaction-scroll-right-btn:hover,
  .transaction-scroll-right-btn:focus {
    background: #fff;
    color: #23527c;
    outline: none;
  }

  .transaction-scroll-right-btn:focus {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18), 0 0 0 2px rgba(51, 122, 183, 0.35);
  }

  .table-responsive {
    max-height: 235px;
    overflow-x: auto;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// Transaction.vue?3b431425